import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Table,
    notification
} from "antd";
import { skeletonData } from '../../components/skeletons/Plan';
import apiClient from "../../services/api";
import { Link } from 'react-router-dom';
import { EditOutlined } from "@ant-design/icons";
import { handleApiError, handleApiInfo } from "../../utils/errorHandler";
import logger from "../../utils/logger";

// table code start
const columns = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "Description",
        dataIndex: "description",
        key: "description",
    },
    {
        title: "Price",
        dataIndex: "price",
        key: "price",
    },
    {
        title: "Status",
        key: "status",
        dataIndex: "status",
    },
    {
        title: "Action",
        key: "action",
        dataIndex: "action",
    }
];

function PlanList() {
    const [planList, setPlanList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPlanList();
    }, []);

    async function getPlanList() {
        try {
            setLoading(true);
            const response = await apiClient.get('/api/plan');
            if (response.data.success) {
                setPlanList(response.data.result);
            } else {
                setPlanList([]);
            }
        } catch (error) {
            handleApiError(error);
            logger.error("API error:", error);
            setPlanList([]);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Plan"
                            extra={
                                <>
                                    {/* <Link className="custom-btn" to="/plan/add">Add</Link> */}
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={loading ? skeletonData : planList.map((item, index) => ({
                                        key: index.toString(),
                                        name: (
                                            <div className="author-info">
                                                <p>{item.name}</p>
                                            </div>
                                        ),
                                        description: (
                                            <div className="author-info">
                                                <p>{item.description}</p>
                                            </div>
                                        ),
                                        price: (
                                            <div className="author-info">
                                                <p>€{item.price}</p>
                                            </div>

                                        ),
                                        status: (
                                            <span className={item.isActive ? 'text-success' : 'text-danger'}>
                                                {item.isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        ),
                                        action: (
                                            <div className="button-container">
                                                <Link to={`/plan/update/${item._id}`} className="update-btn">
                                                    <EditOutlined />
                                                </Link>
                                            </div>
                                        )
                                    }))}
                                    pagination={false}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default PlanList;
